import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FaUserGraduate, FaUserTie, FaDashcube, FaUserLock, FaTags, FaFileAlt } from "react-icons/fa";
import axios from "axios";

const Sidebar = () => {
  const location = useLocation();
  const managers = [
    { name: "Employee Manager", path: "/employee-manager", icon: <FaUserTie className="mr-3 text-xl"/> },
    { name: "Student Manager", path: "/student-manager", icon: <FaUserGraduate className="mr-3 text-xl"/> },
    { name: "College Manager", path: "/college-manager", icon: <FaUserGraduate className="mr-3 text-xl"/> },
    { name: "Course Manager", path: "/course-manager", icon: <FaUserGraduate className="mr-3 text-xl"/> },
    { name: "Category Manager", path: "/category-manager", icon: <FaTags className="mr-3 text-xl"/> },
    { name: "Admission Manager", path: "/admission-manager", icon: <FaFileAlt className="mr-3 text-xl"/> },
    { name: "Cold leads dump", path: "/nl-nc-student-manager", icon: <FaUserGraduate className="mr-3 text-xl"/> },
  ];
  const navigate = useNavigate()
  const isActive = (path) => location.pathname === path;
  const [profile, setProfile] = useState("")
  const [userRole, setUserRole] = useState(localStorage.getItem("userData"));
   const [permissions, setPermissions] = useState([
      managers.reduce((acc, manager) => {
        acc[manager.name] = { add: true, view: true, name: manager?.name, path: manager?.path };
        return acc;
      }, {})
    ]);
  const fetchData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-profile`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
    setProfile(response?.data?.users?.name);
  };

  useEffect(() => {
    fetchData();
    if(!localStorage.getItem('token')){
      navigate("/login")
    }
  }, []);

  useEffect(()=>{
    if(localStorage.getItem("userData")){
      let data = JSON.parse(localStorage.getItem("userData"))
      setUserRole(data)
      if(data?.role === "subadmin"){
      setPermissions([data?.managers])
      }
    }
  },[])

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-100 via-orange-100 to-white shadow-xl text-gray-800">
      {/* Logo and Welcome Section */}
      <div className="flex items-center justify-center p-6 border-b border-gray-300">
        <div className="text-center">
          <img
            src="/images/logo.png"
            alt="logo"
            className="w-30 h-16 mx-auto"
          />
          <NavLink to="/edit-profile"><h2 className="text-lg font-bold mt-2 text-blue-800">Welcome,<br/> {profile}!</h2></NavLink>
        </div>
      </div>

      {/* Navigation Items */}
      <nav className="flex-1">
        <ul>
        <li>
            <NavLink
              to="/"
              className={`flex items-center px-4 py-3 transition ${
                isActive("/") ? "bg-blue text-white" : "hover:bg-orange hover:text-white"
              }`}
            >
              <FaDashcube className="mr-3 text-xl" />
              <span className="font-medium">Dashboard</span>
            </NavLink>
          </li>
          {
            permissions?.map((v, i) => {
             return Object.keys(v)?.map((e) => {
                if(v[e]?.add || v[e]?.view){
                  return <li>
                  <NavLink
                    to={`${v[e]?.path}`}
                    className={`flex items-center px-4 py-3 transition ${
                      isActive(`${v[e]?.path}`) ? "bg-blue text-white" : "hover:bg-orange hover:text-white"
                    }`}
                  >
                    {v[e]?.icon ? v[e]?.icon :  <FaUserGraduate className="mr-3 text-xl" />}
                   
                    <span className="font-medium">{v[e]?.name}</span>
                  </NavLink>
                </li>
                }
              })
            
            })
          }
         
        </ul>
      </nav>

      {/* Footer */}
      <div className="flex p-4 border-t border-gray-300 text-center text-sm bg-gray-50 text-gray-600 cursor-pointer">
      <FaUserLock className="mr-3 text-xl" /><span className="font-medium" onClick={()=>{
        localStorage.clear()
        navigate("/login")
      }}>Logout</span>
      </div>
      <div className="p-4 border-t border-gray-300 text-center text-sm bg-gray-50 text-gray-600">
        &copy; 2025 AdmissionDekhoo.
      </div>
    </div>
  );
};

export default Sidebar;
